import CognitoError from "./CognitoError";

export default CognitoError;
